import axios from "./axiosInstance";

export function login(data) {
  return axios.post("/api/provider-dashboard/login", data);
}

export function fetchProfile() {
  return axios.get("/api/provider-dashboard/profile");
}

export function verifyProviderEmail(data) {
  return axios.post("/api/provider-dashboard/verify-email", data);
}

export function resetProviderPassword(data) {
  return axios.post("/api/provider-dashboard/reset-password", data);
}

export function createCertNumber(data) {
  return axios.post("/api/auth/sms", data);
}

export function verifyCertNumber(data) {
  return axios.post("/api/auth/sms/verify", data);
}
